import global from "global";

const webContextProvider = () => global.asos.webContext.getWebContext();

export default webContextProvider;
